import * as THREE from "three";

export default class Moon {
  constructor() {
    this.mesh = new THREE.Mesh();

    const radius = 1;
    const segments = 32;

    const geometry = new THREE.SphereGeometry(radius, segments, segments);

    const textureLoader = new THREE.TextureLoader();
    const textureUrl = "https://raw.githubusercontent.com/afonsopacifer/cdn/master/moonmap1k.jpg";
    const texture = textureLoader.load(textureUrl);

    const material = new THREE.MeshPhongMaterial({ map: texture });

    this.mesh.geometry = geometry;
    this.mesh.material = material;

    this.mesh.castShadow = true;
    this.mesh.receiveShadow = true;
  }
}